var ua = navigator.userAgent.toLowerCase();
var isiOS = (ua.indexOf('iphone') > -1) || (ua.indexOf('ipad') > -1);
if(isiOS) {
  var viewport = document.querySelector('meta[name="viewport"]');
  if(viewport) {
    var viewportContent = viewport.getAttribute('content');
    viewport.setAttribute('content', viewportContent + ', user-scalable=no');
  }
}

$(function(){
  //追従メニューの複製＋クラス付与
  $(".h_wrap").clone().addClass('h_fixed').appendTo("#header");

  var headerHeight = $("#header").outerHeight();
  $(window).scroll(function() {
      if ($(this).scrollTop() > headerHeight) {
          $(".h_fixed").addClass("viewed");
      } else {
          $(".h_fixed").removeClass("viewed");
      }
  });

  //ヘッダーメニューホバー時のコンテンツ表示
  var wsMenu = window.matchMedia('screen and (min-width: 1001px)');
  function checkBreakPoint(wsMenu) {
    //スマホ向け
    if (!wsMenu.matches) {
    }
    //PC向け
    else {
      $(".h_menu").each(function(){
        $(this).find(".menu_toggle a").hover(function() {
          $(this).parents(".h_wrap").find(".h_slidedown_menu").addClass("open");
        },
        function() {
          $(this).parents(".h_wrap").find(".h_slidedown_menu").removeClass("open");
        });
      });
      $(".h_slidedown_menu").each(function(){
        $(this).hover(function() {
          $(this).addClass("open");
        },
        function() {
          $(this).removeClass("open");
        });
      });

      $(".h_slidedown_menu").hover(function() {
        $(".menu_toggle").addClass("open");
      },
      function() {
        $(".menu_toggle").removeClass("open");
      });
    }
  }
  // ブレイクポイントの瞬間に発火
  wsMenu.addListener(checkBreakPoint);
  // 初回の実行
  checkBreakPoint(wsMenu);

  //ハンバーガーメニュー制御
  $(".menu_trigger").each(function(){
    $(this).click(function(){
      $(this).parents(".h_wrap").find(".h_slideright_menu").toggleClass("viewed");
      $("html").toggleClass("content_fixed");
    });
  });
  $(".h_slideright_menu_bg, .slideright_menu_btn_close, .btn_close").click(function(){
    $(".h_slideright_menu").removeClass("viewed");
    $("html").removeClass("content_fixed");
  });

  //開閉メニューの矢印回転
  $(".toggle_link > a").each(function(){
    $(this).click(function(){
      $(this).toggleClass("open");
      $(this).next(".toggle_blk").slideToggle(200);
    });
  });

  //フッターメニューの開閉
  $(".f_wrap_sp .f_top_blk").each(function(){
    $(this).find(".toggle_link").click(function(){
      $(this).next("ul").slideToggle(200);
    });
  });


  //ページトップ
  var showFlag = false;
  var topBtn = $('.btn_page_top');    
  var showFlag = false;
  $(window).scroll(function () {
    if ($(this).scrollTop() > 300) {
        if (showFlag == false) {
            showFlag = true;
            topBtn.addClass("viewed");
        }
    } else {
        if (showFlag) {
            showFlag = false;
            topBtn.removeClass("viewed");
        }
    }
  });
  topBtn.click(function () {
    $('body,html').animate({
        scrollTop: 0
    }, 500);
    return false;
  });

  $(window).on('scroll', function (){
  var elem = $('.fade_up');
  var isViewed = 'viewed';
    elem.each(function () {
    var elemOffset = $(this).offset().top;
    var scrollPos = $(window).scrollTop();
    var wh = $(window).height();
      if(scrollPos > elemOffset - wh + (wh / 4) ){
      $(this).addClass(isViewed);
      }
    });
  });
});

$(window).on('load', function() {
  //タイトルにクラス付与
  setTimeout(function(){
      $(".main_ttl").addClass("ready");
  },500);
});

